// @tennis-matches/core/constants/defaultSettings
// Default user settings
// Note: This is a minimal copy to avoid circular dependency with @tennis-matches/services

/**
 * Default user settings
 * This is a minimal definition to avoid circular dependencies.
 * For the full definition with helper functions, see @tennis-matches/services/settings
 */
export const DEFAULT_SETTINGS = {
  fontSize: "m",
  courtColor: "blue", // Default: indoor (blue)
  trainerstundenCalendarDayStart: "08:00",
  trainerstundenCalendarDayEnd: "20:00",
  trainerstundenTrainingState: "",
  trainerstundenSchoolHolidaysEnabled: false,
  trainerstundenBelegungPlanningEnabled: false,
};
